import { Grid, Rating, Typography } from '@mui/material'
import { ButtonBack, ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms'
import { swalActive, swalError, swalSuccess } from '../../../components/alert/swal'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { CardOnlineCourses } from './online-courses';
import { useEffect, useState } from 'react';
import { PublishOnlineCourseApi } from '../../../api/publish-online-course/publish-online-course.api';
import ListRelated from './list/list-related';
import moment from 'moment';
import { MyOnlineCourseShoppingCartApi } from '../../../api/my_online_course_shopping_cart/my_online_course_shopping_cart.api';
import { OnlineCourseApi } from '../../../api/cms-online-course/online_course.api';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import ModalCustom from '../../../components/modal/ModalCustom';
import InputTextField from '../../../components/input/inputTextField';
import StarIcon from '@mui/icons-material/Star';
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import FeedIcon from '@mui/icons-material/Feed';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ClassIcon from '@mui/icons-material/Class';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useTranslation } from 'react-i18next'
export default function DetailOnlineCourse() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [detail, setDetail] = useState<any>()
    const [basicInfo, setBasicInfo] = useState<any>()
    const { id } = useParams();
    const [open, setOpen] = useState<boolean>(false);
    const [form, setForm] = useState<any>()
    const handleClose = async () => {
        setOpen(false)
        setForm(null)
    }
    const getDetail = async () => {

        const res = await PublishOnlineCourseApi.id(id);
        const data = res.data
        if (res.status < 300) {
            setDetail(data?.data)
            setBasicInfo(data?.data?.basic_info?.data)
        }
    }
    const getReview = async () => {

        const res = await PublishOnlineCourseApi.getReview(id);
        const data = res.data
        if (res.status < 300) {
            console.log(data?.data)
        }
    }

    useEffect(() => {
        if (id) {
            getDetail()
            getReview()
        }

    }, [])
    const handleSubmit = async () => {

        const formData = new FormData();

        //DRAFT
        formData.append('payment_date_time', `${moment().format('YYYY-MM-DDTHH:mm')}`);
        formData.append('payment_amount', '0');
        if (id) {
            await PublishOnlineCourseApi.purchase(formData, id).then((res: any) => {
                if (res.status < 300) {
                    // swalSuccess('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว')
                    // alertActive('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                    // handleSubmit()
                    // reactToPrintFn()
                    swalSuccess(t("สั่งซื้อ เรียบร้อยแล้ว"), undefined, undefined, () => {
                        // navigate(routeName.students.OnlineCourseDetail.replace(':id', `${id}`))
                        getDetail()
                    })


                    // }, 'info',)
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
            })

        }
    }
    const handleSubmitBookmark = async () => {
        await PublishOnlineCourseApi.bookmark(!detail?.bookmark, id).then((res: any) => {
            if (res.status < 300) {
                // swalSuccess('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว')
                // alertActive('บันทึกวุฒิบัตร', 'บันทึกวุฒิบัตร เรียบร้อยแล้ว', 'ดูตัวอย่าง', 'ตกลง', () => {
                // handleSubmit()
                // reactToPrintFn()


                // }, 'info',)
                getDetail()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })
    }
    const handleShoppingCart = async () => {
        const body = {
            id_online_course: id
        }
        await MyOnlineCourseShoppingCartApi.post(body).then((res: any) => {
            if (res.status < 300) {
                swalActive(t("สั่งซื้อ"), t("เพิ่มรายการลงในรถเข็นเรียบร้อยแล้ว เรียบร้อยแล้ว"), () => {
                    navigate(routeName.students.ShoppingCart)
                }, 'info', t("ชำระเงิน"))
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })
    }
    const handleReview = async () => {
        const body = {
            rating: form?.rating,
            review: form?.review
        }
        await PublishOnlineCourseApi.patchReview(id, body).then((res: any) => {
            if (res.status < 300) {
                handleClose()
                swalSuccess(t("รีวิวเรียบร้อยแล้ว"),)
                getDetail()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })
    }
    const handleCancel = async () => {

        await PublishOnlineCourseApi.cancel(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t("ยกเลิกเรียบร้อยแล้ว"),)
                getDetail()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || t("เกิดข้อผิดพลาด"))
        })
    }

    // console.log(moment().format('YYYY-MM-DDTHH:mm'));
    return (
        <div style={{ margin: '-40px -50px', padding: '32px 100px', position: "relative" }}>
            <img src={
                process.env.REACT_APP_FILE_BASE_API + '/' + basicInfo?.cover_image?.file_path + basicInfo?.cover_image?.file_name
                // 'https://images.unsplash.com/photo-1520209759809-a9bcb6cb3241?fm=jpg&q=60&w=3000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1nfGVufDB8fDB8fHww'
            } style={{ position: 'absolute', top: '0px', left: '0px', width: '100%', height: '370px', zIndex: -1, objectFit: 'cover', objectPosition: 'center' }} />
            <Grid container spacing={2}>
                <Grid item lg={8}>
                    <div style={{ padding: '32px 0px', height: '370px' }}>
                        <Typography sx={{ color: "#fff" }}>{basicInfo?.online_course_no}</Typography>
                        <Typography variant='h2' sx={{
                            color: "#fff", display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: "1",
                            overflow: "hidden",
                        }}>{basicInfo?.online_course_name}</Typography>
                        <Typography sx={{
                            color: "#fff", display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: "3",
                            overflow: "hidden",
                        }}>{basicInfo?.online_course_description}</Typography>
                        <Typography sx={{ color: "#fff" }}>{t("อาจารย์ผู้สอน :")} {basicInfo?.online_course_teacher}</Typography>
                        <div style={{
                            margin: '10px 0px'
                        }}>
                            <Typography sx={{ color: "#fff" }}>{t("คะแนน")}</Typography>
                            <div style={{ display: "flex", gap: '10px' }}>
                                <Typography sx={{ color: "#fff" }}>{detail?.rating}</Typography>
                                <Rating readOnly value={+detail?.rating} />
                                {/* <Typography sx={{ color: "#fff" }}>(100 รีวิว)</Typography> */}
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <ButtonPrimary
                                onClick={() => {
                                    handleSubmitBookmark()
                                }}
                                mode="add"
                                buttonName={detail?.bookmark ? t("ยกเลิกบันทึกหลักสูตร") : t("บันทึกหลักสูตร")}
                                btnProps={{
                                    width: "300px",
                                    bg: detail?.bookmark ? '#F79009' : '#ffff',
                                    text: detail?.bookmark ? '#ffff' : '#000',
                                }}
                                startIconComponent={<BookmarksIcon />}
                            />
                            <ButtonPrimary
                                onClick={() => {
                                    setOpen(true)
                                }}
                                mode="add"
                                buttonName={t("รีวิว")}
                                btnProps={{
                                    // width: "300px",
                                    bg: '#F79009',
                                    text: '#ffff',
                                }}
                                startIconComponent={<StarIcon />}
                            />
                        </div>
                    </div>
                    <div >
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("คำอธิบายหลักสูตร")}</Typography>
                            <Typography>{basicInfo?.online_course_description}</Typography>
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("วัตถุประสงค์")}</Typography>
                            <Typography>{basicInfo?.online_course_objective}</Typography>
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("หลักสูตรนี้เหมาะสำหรับ")}</Typography>
                            <Typography>{basicInfo?.online_course_suitable_for}</Typography>
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("ระดับเนื้อหา")}</Typography>
                            <Typography>{basicInfo?.online_course_lv}</Typography>
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("หลักสูตรแนะนำก่อนเข้าเรียน")}</Typography>
                            {basicInfo?.online_course_ref?.map((item: any) => {
                                return (
                                    <Typography sx={{ color: "#F79009", textDecoration: 'underline' }}>{item?.online_course_ref}</Typography>
                                )
                            })}
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("การรับวุฒิบัตร")}</Typography>
                            <Typography>{t("เข้าเรียนไม่น้อยกว่า 80% ของเวลาเรียนทั้งหมด และสอบผ่านไม่น้อยกว่า 70% ของคะแนนโดยรวมทั้งหมด")}</Typography>
                        </div>
                        <div style={{ marginBottom: '32px' }}>
                            <Typography variant='h5'>{t("แท็กที่เกี่ยวข้อง")}</Typography>
                            <div style={{ display: "flex", gap: '10px' }}>
                                {basicInfo?.online_course_tag?.map((item: any) => {
                                    return (
                                        <div

                                            style={{ border: "1px solid #000", borderRadius: '50px', color: '#000', padding: '8px 10px', textAlign: 'center' }}>
                                            {item?.online_course_tag}
                                        </div>

                                    )
                                })}

                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item lg={4}>
                    <div style={{
                        boxShadow: '0px 0px 7px -2px #1018281A',
                        padding: '16px',
                        borderRadius: '16px',
                        minHeight: '360px',
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        background: "#fff"
                    }}>
                        <img src={process.env.REACT_APP_FILE_BASE_API + '/' + basicInfo?.cover_image?.file_path + basicInfo?.cover_image?.file_name} style={{ width: '100%', height: '200px', objectFit: 'cover', objectPosition: 'center' }} />
                        <Typography sx={{ color: "#828282" }}>{t("ค่าธรรมเนียม")}</Typography>
                        <Typography variant='h5' sx={{ color: basicInfo?.online_course_amount === '0.00' ? '#0F9F0C' : 'red' }}>{basicInfo?.online_course_amount === '0.00' ? t("ฟรี") : t("{{amount}} บาท", { amount: basicInfo?.online_course_amount })} </Typography>
                        {detail?.payment?.online_course_payment_status !== 'CONFIRMED' ? <div style={{ display: "flex", gap: '10px' }}>
                            <ButtonOutlined
                                onClick={() => {
                                    // swalActive('สั่งซื้อ', 'เพิ่มรายการลงในรถเข็นเรียบร้อยแล้ว เรียบร้อยแล้ว', () => {
                                    navigate(routeName.students.ExampleCourse.replace(':id', `${id}`))
                                    // }, 'info', 'ชำระเงิน')
                                }}
                                buttonName={t("ตัวอย่าง")}
                                btnProps={{
                                    width: '100%'
                                }}
                                startIconComponent={<RemoveRedEyeIcon />}
                            />
                            <ButtonPrimary
                                onClick={() => {
                                    if (basicInfo?.online_course_amount === '0.00') {
                                        handleSubmit()
                                    } else {
                                        handleShoppingCart()
                                    }

                                }}
                                mode="add"
                                buttonName={t("สั่งซื้อ")}
                                btnProps={{
                                    width: '100%'
                                }}
                                startIconComponent={<LocalGroceryStoreIcon />}
                            /></div> :
                            <div style={{ display: "flex", gap: '10px' }}>
                                {['PASSED','FAILED']?.includes(detail?.payment?.online_course_learning_status) ?
                                    <ButtonOutlined
                                        onClick={() => {
                                            // swalActive('สั่งซื้อ', 'เพิ่มรายการลงในรถเข็นเรียบร้อยแล้ว เรียบร้อยแล้ว', () => {
                                            //     navigate(routeName.students.PaymentOnlineCourse.replace(':id', '1'))
                                            // }, 'info', 'ชำระเงิน')
                                            navigate(routeName.students.TakeLesson.replace(':id', `${id}`))
                                        }}
                                        buttonName={t("ผลการเรียน")}
                                        btnProps={{
                                            width: '100%'
                                        }}
                                        startIconComponent={<WysiwygIcon />}
                                    />
                                    : <>
                                        <ButtonPrimary
                                            onClick={() => {
                                                // swalActive('สั่งซื้อ', 'เพิ่มรายการลงในรถเข็นเรียบร้อยแล้ว เรียบร้อยแล้ว', () => {
                                                navigate(routeName.students.TakeLesson.replace(':id', `${id}`))
                                                // }, 'info', 'ชำระเงิน')
                                            }}
                                            buttonName={t("เข้าเรียน")}
                                            btnProps={{
                                                width: '100%'
                                            }}
                                            startIconComponent={<RemoveRedEyeIcon />}
                                        />
                                        {/* <ButtonPrimary
                                            onClick={() => {
                                                swalActive('ยกเลิก', 'ต้องการยกเลิกหรือไม่ ?', () => {
                                                   handleCancel()
                                                }, 'info', 'ยืนยัน')
                                            }}
                                            buttonName={'ยกเลิก'}
                                            btnProps={{
                                                width: '100%',
                                                bg: 'red'
                                            }}
                                        /> */}
                                    </>
                                }
                            </div>}
                        <Typography sx={{ color: "#828282" }}>{t("หลักสูตรนี้ประกอบด้วย")}</Typography>
                        <div style={{ display: "flex", gap: '10px' }}>
                            <AccessTimeFilledIcon />
                            <Typography>{basicInfo?.duration_hour ? t("{{hour}} ชั่วโมง", { hour: basicInfo?.duration_hour }) : t("0 ชั่วโมง")} {basicInfo?.duration_minute ? t("{{minute}} นาที", { minute: basicInfo?.duration_minute }) : ''}</Typography>
                        </div>
                        <div style={{ display: "flex", gap: '10px' }}>
                            <FeedIcon />
                            <Typography>{detail?.study_topics_count} {t("หัวข้อการเรียน")}</Typography>
                        </div>
                        <div style={{ display: "flex", gap: '10px' }}>
                            <InsertDriveFileIcon />
                            <Typography>{detail?.quiz_count} {t("แบบทดสอบ")}</Typography>
                        </div>
                        <div style={{ display: "flex", gap: '10px' }}>
                            <AssignmentIcon />
                            <Typography>{detail?.survey_count} {t("แบบสำรวจ")}</Typography>
                        </div>
                        <div style={{ display: "flex", gap: '10px' }}>
                            <StarIcon />
                            <Typography>{basicInfo?.online_course_diploma ? t("วุฒิบัตร") : '-'}</Typography>
                        </div>
                    </div>
                </Grid>
                {/* <Grid item lg={12}>
                    <div>
                        <Typography variant='h5'>หลักสูตรที่เกี่ยวข้อง</Typography>
                    </div>
                    <Grid container spacing={2}>
                        {[{}, {}, {}, {}, {}, {}]?.map((item: any, index: number) => {
                            return (
                                <Grid item lg={12 / 6} key={index}>
                                    <CardOnlineCourses item={item} />
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid> */}
                <ListRelated tag={basicInfo?.online_course_tag.length > 0 ? basicInfo?.online_course_tag[0]?.id_online_course_tag : ''} />

            </Grid>
            <ModalCustom title={t("รีวิว")} subTitle={t("กรุณาระบุรายละเอียด")} open={open} component={
                <div className='flex flex-col gap-4'>
                    <Rating name="half-rating" size="large" onChange={(e: any) => {
                        // handleChangeValueSearch("leave_type_name", e.target.value);
                        setForm({ ...form, rating: e.target.value })
                    }} />

                    <div>
                        <InputTextField
                            heading={t("รายละเอียด")}
                            placeholder={t("ระบุ")}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                // handleChangeValueSearch("leave_type_name", e.target.value);
                                setForm({ ...form, review: e.target.value })
                            }}
                            value={form?.review || ''}
                            multiline
                            minRow={6}
                            inputHeight={'auto'}
                        />
                    </div>


                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                handleClose()
                            }}
                            buttonName={t("ยกเลิก")}
                        />
                        <ButtonPrimary
                            onClick={() => {
                                handleReview()
                            }}
                            mode='add'
                            buttonName={t("ยืนยัน")}
                        />
                    </div>
                </div>
            } />
        </div>
    )
}
